import React from "react";
import { Dropdown, ButtonGroup, Button } from "react-bootstrap";

const MultiActionDropdown = ({
  variant = "outline-primary",
  btnIcon = null,
  btnText = "Action",
  btnOnClick = () => {},
  menuOptions = [],
  onlyIcon = false,
}) => {
  return (
    <Dropdown
      as={ButtonGroup}
      className="d-inline-flex"
      drop="down"
      style={{ padding: "0rem" }}
      size="sm"
    >
      {/* Primary Action Button */}
      <Button
        variant={variant}
        onClick={btnOnClick}
        className="px-2 d-flex align-items-center"
        style={{ borderTopLeftRadius: "6px", borderBottomLeftRadius: "6px" }}
      >
        {btnIcon && (
          <span className={`${!onlyIcon ? "me-2" : ""}`}>{btnIcon}</span>
        )}
        {!onlyIcon && btnText}
      </Button>

      {/* Dropdown Toggle */}
      <Dropdown.Toggle
        split
        variant={variant}
        className="px-2 border-start-0"
        id="dropdown-split-button"
        style={{ borderTopRightRadius: "6px", borderBottomRightRadius: "6px" }}
      />

      {/* Dropdown Menu - styled to stay within card */}
      <Dropdown.Menu
        align="end"
        className="shadow-sm mt-1"
        style={{
          zIndex: 1050, // Stay above card
          minWidth: "120px", // Uniform size
        }}
      >
        {menuOptions.map((item, idx) => (
          <Dropdown.Item
            key={idx}
            onClick={() => {
              if (item.onClick) item.onClick();
            }}
            className="d-flex align-items-center"
          >
            {item.icon && <span className="me-2">{item.icon}</span>}
            {item.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default MultiActionDropdown;
